export default __webpack_public_path__ + "static/media/illustration_consulting.b3daac0f.png";